import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomcolumnComponent } from './components/grid/customcolumn/customcolumn.component';
import { ColumnFormatPipe } from './components/grid/formatPipe';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TagInputModule } from 'ngx-chips';

import { MessageboxService } from './components/messagebox/messagebox.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BlockUIService } from './services/block-ui.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GridComponent } from './components/grid/grid.component';
import { MultipleCheckboxComponent } from './components/multipleCheckbox/multipleCheckbox';
import { MessageboxComponent } from './components/messagebox/messagebox.component';
import { ErrorMessageComponent } from './components/errorMessage';
import { FileUploadComponent } from './components/fileupload/fileupload.component';
import { NgxUploaderModule } from 'ngx-uploader';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TypeaheadModule.forRoot(),
    TagInputModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxUploaderModule
  ],
  declarations: [
    GridComponent, CustomcolumnComponent, ColumnFormatPipe, MultipleCheckboxComponent, MessageboxComponent,
    ErrorMessageComponent, FileUploadComponent
  ],
  exports: [GridComponent, ErrorMessageComponent, FileUploadComponent
  ],
  providers: [MessageboxService, BlockUIService],
  entryComponents: [MessageboxComponent]
})
export class AngularSharedModule { }
